"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('coupon', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 8.000000)",
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M0,11.3129605 L0,0 L40,0 L40,11.3129605 C37.8814684,12.0679939 36.3636364,14.1052655 36.3636364,16.5 C36.3636364,18.8947345 37.8814684,20.9320061 40,21.6870395 L40,33 L0,33 L0,21.6870395 C2.11853159,20.9320061 3.63636364,18.8947345 3.63636364,16.5 C3.63636364,14.1052655 2.11853159,12.0679939 3.33066907e-16,11.3129605 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("polyline", {
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap,
    points: "14.5454545 6.41666667 20 11.9166667 25.4545455 6.41666667"
  }), _react.default.createElement("path", {
    d: "M13.6363636,13.75 L26.3636364,13.75",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M13.6363636,20.1666667 L26.3636364,20.1666667",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M20,13.75 L20,26.5833333",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }))));
});

exports.default = _default;